<script setup>
import ListingTable from '@/components/dashboard/ListingTable.vue'
import { computed, ref } from 'vue'

definePage({
  meta: {
    public: true,
  },
})

const selectionMode = ref('multiple')
const selectedListingIds = ref([])
const selectedActionKey = ref('export')
const actionResult = ref('')

const availableActions = computed(() => {
  const count = selectedListingIds.value.length

  return [
    {
      key: 'export',
      label: 'Export selected',
      minSelection: 1,
      disabled: count < 1,
    },
    {
      key: 'assign',
      label: 'Assign selected',
      minSelection: 1,
      disabled: count < 1,
    },
    {
      key: 'delete',
      label: 'Delete selected',
      minSelection: 1,
      disabled: count < 1,
    },
  ]
})

const selectedAction = computed(() => {
  return availableActions.value.find(action => action.key === selectedActionKey.value) ?? availableActions.value[0]
})

const onSelectionChange = ids => {
  selectedListingIds.value = Array.isArray(ids) ? ids : []
}

const onSelectionConfirm = ids => {
  const action = selectedAction.value
  const selection = Array.isArray(ids) ? ids : []

  if (!action || selection.length === 0) {
    actionResult.value = 'Nessuna azione eseguita: seleziona almeno un listing.'

    return
  }

  actionResult.value = `Azione "${action.key}" richiesta su listing IDs: [${selection.join(', ')}]`
}

const onSelectionCancel = () => {
  selectedListingIds.value = []
  actionResult.value = 'Selezione annullata.'
}
</script>

<template>
  <VContainer
    fluid
    class="py-6"
  >
    <VCard class="mb-4">
      <VCardTitle class="text-h6">
        ListingTable Bulk Actions Demo
      </VCardTitle>
      <VCardText>
        <VRow class="ga-0">
          <VCol
            cols="12"
            md="4"
          >
            <VSelect
              v-model="selectionMode"
              label="Selection mode"
              :items="[
                { title: 'None', value: 'none' },
                { title: 'Single', value: 'single' },
                { title: 'Multiple', value: 'multiple' },
              ]"
              item-title="title"
              item-value="value"
            />
          </VCol>

          <VCol
            cols="12"
            md="4"
          >
            <VSelect
              v-model="selectedActionKey"
              label="Next action on confirm"
              :items="availableActions"
              item-title="label"
              item-value="key"
            />
          </VCol>

          <VCol
            cols="12"
            md="4"
            class="d-flex align-center"
          >
            <div class="text-body-2">
              Selected IDs: {{ selectedListingIds.length ? selectedListingIds.join(', ') : 'none' }}
            </div>
          </VCol>
        </VRow>

        <VAlert
          type="info"
          variant="tonal"
          class="mt-2"
        >
          La tabella emette selezione e conferma. Questa pagina decide cosa fare (export/assign/delete) senza accoppiare logica nel componente.
        </VAlert>

        <VAlert
          v-if="actionResult"
          type="success"
          variant="tonal"
          class="mt-3"
        >
          {{ actionResult }}
        </VAlert>
      </VCardText>
    </VCard>

    <ListingTable
      endpoint="/api/secretary/listings"
      :selection-mode="selectionMode"
      :selected-listing-ids="selectedListingIds"
      selection-confirm-label="Conferma azione"
      selection-cancel-label="Annulla selezione"
      @update:selected-listing-ids="selectedListingIds = $event"
      @selection-change="onSelectionChange"
      @selection-confirm="onSelectionConfirm"
      @selection-cancel="onSelectionCancel"
    />
  </VContainer>
</template>
